window.addEventListener("scroll", scrollHandler);
window.addEventListener("onLoad", () => {
    window.addEventListener("scroll", scrollHandler);
});


var StickyCartHeader = document.getElementById("StickyCartHeader");
var StickyCartHeaderReferencePoint = document.getElementById("StickyCartHeaderReferencePoint");

function scrollHandler() {
    var scrollTop = window.scrollY;

    if(StickyCartHeaderReferencePoint != null && StickyCartHeader != null){
        if (!StickyCartHeader.classList.contains("active") && scrollTop + 102 >= StickyCartHeaderReferencePoint.offsetTop) {
            StickyCartHeader.classList.add("active");
        }else if(StickyCartHeader.classList.contains("active") && scrollTop + 102 < StickyCartHeaderReferencePoint.offsetTop){
            StickyCartHeader.classList.remove("active");
        }
    }
}